// 2Play product page: region checker, visitor-language line, and the Steam trailer (HLS).
(() => {
  /* ---------------------------------------------------------------- Modals */
  // Opening and closing is site-wide (2play-global.js); prepare the region checker when its window opens.
  document.addEventListener('tp:modal-open', (event) => initRegionChecker(event.target));

  /* ---------------------------------------------------------------- Regions */
  function allows(rule, country) {
    const white = Array.isArray(rule.whitelist) ? rule.whitelist : [];
    const black = Array.isArray(rule.blacklist) ? rule.blacklist : [];
    if (white.length > 0) return white.includes(country);
    return !black.includes(country);
  }

  function initRegionChecker(root) {
    const checker = root.querySelector('[data-tp-region-checker]');
    if (!checker || checker.dataset.ready) return;
    checker.dataset.ready = '1';
    let rules = [];
    try { rules = JSON.parse(checker.querySelector('[data-tp-region-rules]').textContent); } catch (e) { rules = []; }
    const select = checker.querySelector('[data-tp-region-select]');
    const result = checker.querySelector('[data-tp-region-result]');
    const update = () => {
      const code = select.value;
      const name = select.options[select.selectedIndex]?.textContent || code;
      const ok = rules.some((rule) => allows(rule, code));
      result.textContent = (ok ? result.dataset.ok : result.dataset.ko).replace('%s', name);
      result.classList.toggle('is-ok', ok);
      result.classList.toggle('is-ko', !ok);
    };
    select.addEventListener('change', update);
    update();
  }

  /* ---------------------------------------------------------------- Languages */
  function initLanguages(root = document) {
    root.querySelectorAll('[data-tp-langs]').forEach((box) => {
      const lines = [...box.querySelectorAll('.tp-lang[data-code]')];
      if (lines.length < 2) return;
      const wanted = (navigator.languages || [navigator.language]).filter(Boolean).map((l) => l.toLowerCase());
      let match = null;
      for (const tag of wanted) {
        match = lines.find((l) => l.dataset.code === tag)
          || lines.find((l) => l.dataset.code && l.dataset.code.split('-')[0] === tag.split('-')[0]);
        if (match) break;
      }
      if (!match) return; // keep the server's choice (store language or English)
      lines.forEach((l) => { l.hidden = l !== match; });
    });
  }

  /* ---------------------------------------------------------------- Trailer (HLS) */
  const HLS_JS = 'https://cdn.jsdelivr.net/npm/hls.js@1.7.3/dist/hls.min.js';
  let hlsLoading = null;
  function loadHls() {
    if (window.Hls) return Promise.resolve(window.Hls);
    if (!hlsLoading) {
      hlsLoading = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = HLS_JS;
        script.async = true;
        script.onload = () => resolve(window.Hls);
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
    return hlsLoading;
  }
  async function attach(video) {
    if (video.dataset.hlsReady) return;
    video.dataset.hlsReady = '1';
    const src = video.dataset.hlsSrc;
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = src;
      video.play().catch(() => {});
      return;
    }
    try {
      const Hls = await loadHls();
      if (Hls && Hls.isSupported()) {
        const hls = new Hls({ capLevelToPlayerSize: true });
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(() => {}));
      }
    } catch (e) {
      console.warn('2Play: trailer could not be loaded', e);
    }
  }
  function initTrailers(root = document) {
    root.querySelectorAll('video[data-hls-src]').forEach((video) => {
      if (video.dataset.hlsBound) return;
      video.dataset.hlsBound = '1';
      video.addEventListener('play', () => attach(video), { once: true });
      video.addEventListener('click', () => attach(video), { once: true });
    });
  }

  function init(root) {
    initLanguages(root);
    initTrailers(root);
  }
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
